var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgApiDocumentation = function SvgSvgApiDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-api-documentation_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.008 40.648a21.504 21.504 0 1 1-43.008 0 21.504 21.504 0 0 1 43.008 0Z",
    fill: "#81E6D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.283 31.434a.996.996 0 0 0-.943 1.039v16.35a.996.996 0 0 0 .943 1.042h12.45a.992.992 0 0 0 .942-1.036V37.123l-5.14-5.69h-8.252Z",
    stroke: "#2D2F7A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.57 36.728h4.062l-5.252-5.251v4.06a1.191 1.191 0 0 0 1.19 1.192v-.001Z",
    stroke: "#2D2F7A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.917 39.556h6.636M33.917 42.833h6.636M33.917 46.11h6.636",
    stroke: "#2D2F7A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.644 86.728c20.36 0 36.864-16.505 36.864-36.864 0-20.36-16.504-36.864-36.864-36.864-20.359 0-36.864 16.505-36.864 36.864 0 20.36 16.505 36.864 36.864 36.864Z",
    fill: "#2D2F7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.436 36.046H137.9a4.607 4.607 0 0 1 4.608 4.608v18.464a4.61 4.61 0 0 1-4.608 4.608h-18.464a4.607 4.607 0 0 1-4.608-4.608V40.652a4.607 4.607 0 0 1 4.608-4.606Z",
    stroke: "#81E6D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.687 45.42h5.955a1.483 1.483 0 0 1 1.485 1.488v5.953a1.491 1.491 0 0 1-1.485 1.487h-5.955a1.486 1.486 0 0 1-1.484-1.487v-5.953a1.488 1.488 0 0 1 1.484-1.487ZM125.163 35.234v-3.366m7.004 3.366v-3.366M132.167 64.534V67.9m-7.004-3.366V67.9M114.014 53.385h-3.366m3.366-7.004h-3.366M143.314 46.38h3.366m-3.366 7.005h3.366",
    stroke: "#81E6D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.397 66.226a7.658 7.658 0 1 1-15.316 0 7.658 7.658 0 0 1 15.316 0ZM73.212 30.06a4.608 4.608 0 1 1 9.217 0 4.608 4.608 0 0 1-9.217 0Z",
    fill: "#EAEAF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.184 65.224a21.503 21.503 0 1 1-43.006 0 21.503 21.503 0 0 1 43.006 0Z",
    fill: "#81E6D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M224.08 63.037v-3.262a1.127 1.127 0 0 0-1.121-1.12h-7.271a1.127 1.127 0 0 1-1.12-1.122v-.543a1.125 1.125 0 0 0-1.121-1.12h-4.642a1.124 1.124 0 0 0-1.121 1.12v9.958",
    stroke: "#2D2F7A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M226.861 63.041h-14.515a1.129 1.129 0 0 0-1.029.678l-3.521 8.18a1.125 1.125 0 0 0 .501 1.428c.162.088.344.135.529.136h14.517a1.126 1.126 0 0 0 1.029-.678l3.52-8.18a1.126 1.126 0 0 0-1.031-1.564Z",
    stroke: "#2D2F7A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "svg-api-documentation_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 67,
    width: 10,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.089 67.605h9.052v9.052h-9.052v-9.052Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-api-documentation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.962 76.657h-4.694a2.181 2.181 0 0 1-2.179-2.18v-4.693a2.185 2.185 0 0 1 2.179-2.18h4.694a2.182 2.182 0 0 1 2.179 2.18v4.694a2.185 2.185 0 0 1-2.179 2.179Zm-4.694-7.373a.506.506 0 0 0-.503.503v4.69a.504.504 0 0 0 .503.503h4.694a.5.5 0 0 0 .5-.502v-4.694a.5.5 0 0 0-.503-.503l-4.691.003Z",
    fill: "#EAEAF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "svg-api-documentation_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 33,
    width: 14,
    height: 15
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.929 47.009h-13.877V33.133h13.877v13.876Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-api-documentation_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.393 33.133h7.195a3.343 3.343 0 0 1 3.341 3.34v7.196a3.345 3.345 0 0 1-3.341 3.34h-7.194a3.344 3.344 0 0 1-3.34-3.34v-7.195a3.344 3.344 0 0 1 3.34-3.34m7.194 11.306a.773.773 0 0 0 .771-.771v-7.195a.773.773 0 0 0-.771-.771h-7.194a.769.769 0 0 0-.771.77v7.196a.77.77 0 0 0 .771.77h7.194Z",
    fill: "#EAEAF7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-api-documentation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-1)",
    d: "M0 0h256v140H0z"
  })))));
};
export default SvgSvgApiDocumentation;